import React from 'react'
import { useIntl } from 'react-intl'
import InviteConfirmModal from './InviteConfirmModal'
import InviteIconButton from './InviteIconButton'

export type InviteModalButtonProps = {
	onInviteClick: () => void
}

const InviteModalButton = ({
	onInviteClick,
}: InviteModalButtonProps) => {
	const { formatMessage } = useIntl()
	const [isConfirmModalOpen, setIsConfirmModalOpen] =
		React.useState(false)

	const handleOpenConfirmModal = () => {
		setIsConfirmModalOpen(true)
	}

	const handleCloseConfirmModal = () => {
		setIsConfirmModalOpen(false)
	}
	const handleInviteClick = () => {
		onInviteClick()
		handleCloseConfirmModal()
	}

	return (
		<>
			<InviteIconButton onClick={handleOpenConfirmModal} />
			<InviteConfirmModal
				confirmButtonText={formatMessage({ id: 'global.invite' })}
				open={isConfirmModalOpen}
				onConfirm={handleInviteClick}
				onClose={handleCloseConfirmModal}
			/>
		</>
	)
}

export default InviteModalButton
